import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Product } from 'src/app/classes/utility';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';
import { PriceComponent } from '../price/price.component';

@Component({
    selector: 'app-titles',
    imports: [NgIf, PriceComponent, TitleExtractorPipe],
    templateUrl: './titles.component.html',
    styleUrl: './titles.component.scss'
})
export class TitlesComponent {
  @Input() product!: Product;
}
